import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SET_TOAST } from '../../actions/types';
import './toaster.scss';

export default function Toaster({ toast, dispatch }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (toast && toast.message) {
      setTimeout(() => {
        dispatch({
          type: SET_TOAST,
          payload: null,
        });
      }, 4000);
    }
  }, [toast, dispatch]);

  return (
    <div className={`toaster ${toast && toast.message ? 'isActive' : ''} ${toast && toast.type === 'success' ? 'success' : ''} ${toast && toast.type === 'error' ? 'error' : ''}`}>
      <p>{toast?.message ? t(toast.message) : ''}</p>
    </div>
  );
}
